export interface Pet {
  id: string | number;
  userId?: string;
  name: string;
  species: string;
  breed: string;
  gender?: string;
  dob: string;
  chip: string;
  weight: string;
  features: string;
  photo: string | null;
  city?: string;
  diagnoses?: string[];
  meds?: string[];
  allergies?: string[];
}
export interface Reminder {
  id: string | number;
  petId: string | number;
  userId?: string;
  type: string;
  title: string;
  date: string;
  time?: string;
  recurrence: string;
  notify: string;
  completed?: boolean;
  nextDate?: string | null;
}
export interface ChatMessage {
  id: string | number;
  author: string;
  text: string;
  time: string;
  isMe: boolean;
  userId?: string;
  petPhoto?: string | null;
  rankIcon?: string;
  coords?: [number, number];
  breed?: string;
  gender?: string;
  dob?: string;
  reactions?: Record<string, string[]>;
}
export interface AiMessage {
  role: "user" | "model";
  text: string;
}
export interface LocationItem {
  id: string | number;
  type: "clinic" | "store" | "event" | "park" | "shelter";
  name: string;
  address: string;
  rating: number;
  distance: string;
  time?: string;
  coords: [number, number];
}
export interface ServiceOffer {
  id: string | number;
  userId: string;
  author: string;
  authorPhoto: string | null;
  title: string;
  price: string;
  description: string;
  coords?: [number, number];
  authorBreed?: string;
  authorGender?: string;
  authorDob?: string;
}

export const DOG_BREEDS = [
  "Akita Inu / Акіта-іну",
  "Alabai / Алабай",
  "Amstaff / Амстафф",
  "Bulldog / Бульдог",
  "Cocker Spaniel / Спанієль",
  "Beagle / Бігль",
  "Bichon / Бішон",
  "Boxer / Боксер",
  "Border Collie / Бордер-коллі",
  "Bull Terrier / Бультер'єр",
  "Corgi / Коргі",
  "Dalmatian / Далматин",
  "Jack Russell / Джек-рассел",
  "Doberman / Доберман",
  "Golden Retriever / Ретривер",
  "Yorkie / Йорк",
  "Cane Corso / Кане-корсо",
  "Labrador / Лабрадор",
  "Maltipoo / Мальтіпу",
  "Pug / Мопс",
  "German Shepherd / Вівчарка",
  "Pomeranian / Шпіц",
  "Poodle / Пудель",
  "Rottweiler / Ротвейлер",
  "Samoyed / Самоїд",
  "Dachshund / Такса",
  "French Bulldog / Франц. бульдог",
  "Husky / Хаскі",
  "Chihuahua / Чихуахуа",
  "Shih Tzu / Ши-тцу",
  "Volpino Italiano / Вольпіно італьяно",
  "Mutt / Безпородна",
  "Other / Інша",
];

export const STATIC_LOCATIONS: LocationItem[] = [
  {
    id: 1,
    type: "clinic",
    name: 'Вет-Клініка "Алден"',
    address: "вул. Героїв, 12",
    rating: 4.8,
    distance: "450 м",
    coords: [50.4501, 30.5234],
  },
  {
    id: 2,
    type: "store",
    name: "MasterZoo",
    address: "пр-т Перемоги, 45",
    rating: 4.5,
    distance: "1.2 км",
    coords: [50.458, 30.492],
  },
  {
    id: 3,
    type: "park",
    name: "Майданчик для собак",
    address: "вул. Набережна, 5",
    rating: 4.2,
    distance: "2.1 км",
    coords: [50.44, 30.55],
  },
  {
    id: 4,
    type: "shelter",
    name: 'Притулок "Сіріус"',
    address: "вул. Федорова, 31",
    rating: 4.9,
    distance: "5.4 км",
    coords: [50.42, 30.5],
  },
];

export function calcAge(dob: string | null, t: any): string {
  if (!dob) return "";
  const birth = new Date(dob);
  const now = new Date();
  let years = now.getFullYear() - birth.getFullYear();
  let months = now.getMonth() - birth.getMonth();
  if (months < 0) {
    years--;
    months += 12;
  }
  if (years < 0) return "";
  return years === 0
    ? `${months} ${t.months}`
    : `${years} ${t.years} ${months} ${t.months}`;
}

export function formatDate(iso: string | null): string {
  if (!iso) return "—";
  const [y, m, d] = iso.split("-");
  return `${d}.${m}.${y}`;
}

export function getRank(pts: number, t: any) {
  if (pts < 50) return { name: "🌱", icon: "" };
  if (pts < 150) return { name: "🥉", icon: "" };
  if (pts < 300) return { name: "🥈", icon: "" };
  return { name: "🥇", icon: "" };
}

export function getDistance(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
): number {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}
